import { useLocale } from "@/hooks/useLocale";
import { DynamicText } from "@/ui/DynamicText";
import { Form } from "@/ui/Form";
import classes from "./styles.module.scss";
import clsx from "classnames";
import { useLink } from "@/hooks/useLink";
import { useNearViewport } from "@/hooks/useNearViewport";
import { DynamicHtml } from "@/ui/DynamicHtml";
import sourceflowEnums from "@/sourceflow.enums";

/**
 * Footer contact form that defers mounting the SourceFlow form (and its
 * formio.full.min.js payload) until the footer scrolls near the viewport.
 *
 * @param {Object} props
 * @returns {JSX.Element}
 */
export const FooterForm = ({ className }) => {
  const locale = useLocale();
  const link = useLink();
  const [containerRef, isNearViewport] = useNearViewport();

  const onSubmitDone = () => {
    if (typeof window !== "undefined") {
      window.location.href = link("form.complete");
    }
  };

  return (
    <div ref={containerRef} className={clsx(className, classes.form)}>
      <DynamicText path={`footer.form.title.${locale}`} tag="h2" className="h5 mb-2" />
      <DynamicHtml path={`footer.form.text.${locale}`} className="mb-4 small" />
      {isNearViewport && (
        <Form className="mb-5" formId={sourceflowEnums.forms.contactUs[locale]} onSubmitDone={onSubmitDone} />
      )}
    </div>
  );
};
